// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.revising-number-policy {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 14px;
  padding: 12px 14px;
  color: #17365d;
  background: #f3f8ff;
  border: 1px solid #cfe0f5;
  border-left: 4px solid #0d6efd;
  border-radius: 8px;
}

.revising-number-policy__icon {
  display: grid;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  color: #0d6efd;
  background: #e2eeff;
  border-radius: 50%;
  place-items: center;
}

.revising-number-policy__content {
  min-width: 0;
}
.revising-number-policy__content strong {
  display: block;
  margin-bottom: 2px;
  color: #12335b;
  font-size: 13px;
}
.revising-number-policy__content p {
  margin: 0;
  color: #4b6380;
  font-size: 12px;
  line-height: 1.45;
}

.revising-number-policy__rules {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px;
}
.revising-number-policy__rules span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  color: #36516f;
  background: #ffffff;
  border: 1px solid #d9e5f4;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.revising-number-policy__rules i {
  color: #0d6efd;
}

.revising-number-filter-bar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #dce5f0;
  border-radius: 8px;
}

.revising-number-filter-bar__field {
  width: min(100%, 320px);
}
.revising-number-filter-bar__field label {
  margin-bottom: 5px;
  color: #294766;
  font-size: 12px;
  font-weight: 600;
}
.revising-number-filter-bar__field select {
  min-height: 36px;
  color: #17365d;
  font-size: 13px;
  border-color: #c8d5e4;
}

.revising-number-filter-bar__count {
  padding: 5px 10px;
  color: #4c6380;
  background: #f3f7fb;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .revising-number-filter-bar {
    align-items: stretch;
    flex-direction: column;
  }
  .revising-number-filter-bar__field {
    width: 100%;
  }
  .revising-number-filter-bar__count {
    align-self: flex-start;
  }
  .revising-number-policy__rules {
    align-items: flex-start;
    flex-direction: column;
  }
  .revising-number-policy__rules span {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/master/RevisingNumber.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;AACE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACJ;AAEE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AADF;AAGE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;AAKE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAME;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAJJ;;AAQA;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE;IACE,oBAAA;IACA,sBAAA;EALF;EAQA;IACE,WAAA;EANF;EASA;IACE,sBAAA;EAPF;EAUA;IACE,uBAAA;IACA,sBAAA;EARF;EAUE;IACE,mBAAA;EARJ;AACF","sourcesContent":[".revising-number-policy {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-top: 14px;\n  padding: 12px 14px;\n  color: #17365d;\n  background: #f3f8ff;\n  border: 1px solid #cfe0f5;\n  border-left: 4px solid #0d6efd;\n  border-radius: 8px;\n}\n\n.revising-number-policy__icon {\n  display: grid;\n  flex: 0 0 30px;\n  width: 30px;\n  height: 30px;\n  color: #0d6efd;\n  background: #e2eeff;\n  border-radius: 50%;\n  place-items: center;\n}\n\n.revising-number-policy__content {\n  min-width: 0;\n\n  strong {\n    display: block;\n    margin-bottom: 2px;\n    color: #12335b;\n    font-size: 13px;\n  }\n\n  p {\n    margin: 0;\n    color: #4b6380;\n    font-size: 12px;\n    line-height: 1.45;\n  }\n}\n\n.revising-number-policy__rules {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-top: 8px;\n\n  span {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 8px;\n    color: #36516f;\n    background: #ffffff;\n    border: 1px solid #d9e5f4;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    white-space: nowrap;\n  }\n\n  i {\n    color: #0d6efd;\n  }\n}\n\n.revising-number-filter-bar {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 12px;\n  padding: 10px 12px;\n  background: #ffffff;\n  border: 1px solid #dce5f0;\n  border-radius: 8px;\n}\n\n.revising-number-filter-bar__field {\n  width: min(100%, 320px);\n\n  label {\n    margin-bottom: 5px;\n    color: #294766;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  select {\n    min-height: 36px;\n    color: #17365d;\n    font-size: 13px;\n    border-color: #c8d5e4;\n  }\n}\n\n.revising-number-filter-bar__count {\n  padding: 5px 10px;\n  color: #4c6380;\n  background: #f3f7fb;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n@media (max-width: 767px) {\n  .revising-number-filter-bar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .revising-number-filter-bar__field {\n    width: 100%;\n  }\n\n  .revising-number-filter-bar__count {\n    align-self: flex-start;\n  }\n\n  .revising-number-policy__rules {\n    align-items: flex-start;\n    flex-direction: column;\n\n    span {\n      white-space: normal;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
